export const REQUEST_MORE_INFO = 'requestMoreInfo';
